import createDocumentResource, { handleStandardErrors } from 'src/actions/shared/createDocumentResource';
import emptyObserverCreator from 'src/actions/shared/emptyObserverCreator';
import { PublicAnswer } from 'src/models/Answers/AnswerModel';
import * as sharedTypes from 'src/actions/shared/sharedTypes';

const fetch: sharedTypes.AppThunk =
  ({ language = '' }) =>
  async (dispatch, getState, { gateways }) => {
    const { fetchStarted, fetchSuccess, fetchError, fetchRequestError } = publicAnswersResource.actions;

    try {
      dispatch(fetchStarted({}));
      const results = await gateways.publicAnswers.request({}, { lng: language });
      dispatch(fetchSuccess(results));
    } catch (error) {
      handleStandardErrors({ error, dispatch, handleDomainError: fetchError, handleDefaultError: fetchRequestError });
    }
  };

const publicAnswersResource = createDocumentResource<PublicAnswer>({
  name: 'publicAnswers',
  endpoint: 'v1/orgs/:orgId/answers',
  effects: {
    fetch,
  },
  observerCreator: emptyObserverCreator,
});

export default publicAnswersResource;
